export default __webpack_public_path__ + "static/media/healthInsurance.7dd2837d.svg";